import type { ChatroomDataObject } from '#models/services';
import { useMutation } from '#react-query';
import { editChatroom } from '../../services';
import { useAddChatroomToCache } from '../cache';

type EditChatroom = {
  chatroomId: string;
  name?: string;
};

export const useEditChatroomMutation = () => {
  const addChatroomToCache = useAddChatroomToCache();

  return useMutation<ChatroomDataObject, Error, EditChatroom>({
    async mutationFn({ chatroomId, name }: EditChatroom) {
      const { data } = await editChatroom({ body: { name }, routeParams: { id: chatroomId } });

      return data;
    },
    onSuccess(newChatroom) {
      addChatroomToCache({ newChatroom });
    },
  });
};
